<script>
import UniqueReports from "@/components/widgets/bidding-unique-reports.vue"
export default {
    props: {
        data: Object,
    },
    components: {
        UniqueReports
    },
    data(){
        return {
            search: null
        }
    },
    computed: {
        filteredActivity(){
            let data = this.data.activities;
            if(this.search && this.search.trim() !== ""){
                data = data.filter(x => x.activityName.toLowerCase().includes(this.search.toLowerCase()));
            }
            return data;
        }
    },
    methods: {
        addActivity(){
            this.$emit('addActivity');
        },
        updateActivity(act){
            this.$emit('updateActivity', act);
        },
        deleteActivity(act){
            this.$emit('deleteActivity', act);
        },
        getAttachments(act){
            this.$emit('getAttachments', act);
        },
        getDiff(act){
            let scheduleDate = new Date(act.schedule);
            let preEventDate = new Date(act.preEventNotification);
            let diffInMs = scheduleDate - preEventDate;
            let diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            if (diffInDays > 1) {
                return this.formatDateShortWTime(preEventDate);
            } else {
                return preEventDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
            }
        },
        generateReport(id){
            this.$emit('generateReport', id);
        },
        uploadAttachment(actReport, act){
            this.$emit('uploadAttachment', {actReport, act});
        },
        generateNotice(id){
            this.$emit('generateNotice', id);
        },
        titleName(act){
            if(act.bidActivity.activityName.toLowerCase().includes('pre-proc')){
                return `Generate Notice of Meeting & MEMO`;
            }
            if(act.bidActivity.activityName.toLowerCase().includes('posting')){
                return `Generate Bidding Documents`;
            }
            if(act.bidActivity.activityName.toLowerCase().includes('pre-bid')){
                return `Generate Notice of Bidding Activities`;
            }
            if(act.bidActivity.activityName.toLowerCase().includes('notice of award')){
                return `Generate NOA & Indorsement`;
            }
            if(act.bidActivity.activityName.toLowerCase().includes('notice to proceed')){
                return `Generate NTP & Indorsement`;
            }
            return `Generate Notice of Meeting`;
        },
    }
}
</script>
<template>
    <div>
        <div class="my-2 d-flex align-items-center justify-content-between">
            <div>
                <input type="text" class="form-control" v-model="search" placeholder="Search Activity...">
            </div>
            <div>
                <button type="button" class="btn btn-outline-pink" @click="addActivity"><i class="bx bx-plus"></i>Add Activity Schedule</button>
            </div>
        </div>
        <div v-if="!data.activities.length" class="py-5 text-center">
            <h4>No data found.</h4>
        </div>
        <template v-else>
            <div class="card border shadow-none mb-2" v-for="x in filteredActivity" :key="x.id">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div>
                            <h4 class="mb-0 font-size-18">
                                {{x.bidActivity.activityName}} 
                                <a href="javascript:void()" :title="titleName(x)" @click="generateNotice(x.id)"><i class="bx bx-printer"></i></a>
                            </h4>
                            <p class="mb-0 font-size-14"><span class="text-warning">{{x.mode}}</span> on {{formatDateShortWTime(new Date(x.schedule))}} (notify on {{getDiff(x)}})</p>
                            <p class="mb-0 font-size-14 text-green" v-if="x.location">{{x.location}}</p>
                            <template v-if="x.mode != 'Face to Face'">
                                <a :href="x.onlineLink" v-if="x.onlineLink" target="_blank">{{x.onlineLink}}</a>
                                <p class="mb-0">Meeting ID: {{x.meetingNumber}}</p>
                                <p class="mb-0">Meeting Password: {{x.meetingPassword}}</p>
                            </template>
                            <div class="d-flex" v-if="x.bidActivity.bidActivityReports.length">
                                <span class="me-1">Reports:</span>
                                <UniqueReports 
                                    :rfqId="data.rfqId"
                                    :data="x.bidActivityReports"
                                    @generateReport="generateReport"
                                    @uploadAttachment="uploadAttachment($event, x)"
                                />
                            </div>
                        </div>
                        <div class="d-flex">
                            <a href="javascript:void(0);" class="text-info me-1" title="Attachments" @click="getAttachments(x)"><i class="bx bx-paperclip rotate-n45 font-size-22"></i></a>
                            <a href="javascript:void(0);" class="text-success me-1" title="Edit" @click="updateActivity(x)"><i class="bx bx-edit font-size-22"></i></a>
                            <a href="javascript:void(0);" class="text-danger" title="Delete" @click="deleteActivity(x)"><i class="bx bx-trash font-size-22"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>